"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var services_1 = require("../../../services");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var async_state_manager_1 = require("../../async-state-manager");
var abstract_destruction_subject_1 = require("../../abstract-destruction-subject");
var operators_1 = require("rxjs/operators");
var SisInlineTableMainEntityComponent = /** @class */ (function (_super) {
    __extends(SisInlineTableMainEntityComponent, _super);
    function SisInlineTableMainEntityComponent(_kbService, _deService, _currentLanguageProvider) {
        var _this = _super.call(this) || this;
        _this._kbService = _kbService;
        _this._deService = _deService;
        _this._currentLanguageProvider = _currentLanguageProvider;
        _this._valueChange = new core_1.EventEmitter();
        _this._readOnly = false;
        _this._asyncState = new async_state_manager_1.AsyncStateManager();
        return _this;
    }
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "field", {
        get: function () {
            return this._field;
        },
        set: function (value) {
            this._field = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "mainEntityNameFields", {
        get: function () {
            return this._mainEntityNameFields;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "mainEntityName", {
        get: function () {
            return this._mainEntityName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "readOnly", {
        get: function () {
            return this._readOnly;
        },
        set: function (value) {
            this._readOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisInlineTableMainEntityComponent.prototype, "valueChange", {
        get: function () {
            return this._valueChange;
        },
        enumerable: true,
        configurable: true
    });
    SisInlineTableMainEntityComponent.prototype.ngOnInit = function () {
        this._asyncState.addSubscription('initInstanceField', this.initInstanceField());
        this._asyncState.addSubscription('initNameFields', this.initNameFields());
        if (!this._value) {
            this._asyncState.addSubscription('initValueIfNotReceivedFromParent', this.initValueIfNotReceivedFromParent());
        }
    };
    SisInlineTableMainEntityComponent.prototype.isReady = function () {
        return this._asyncState.isReady();
    };
    SisInlineTableMainEntityComponent.prototype.ngOnDestroy = function () {
        this._asyncState.destroy();
    };
    SisInlineTableMainEntityComponent.prototype.mainEntityChanged = function (instanceId) {
        this._value.getProperty(this._instanceField.getMetaFieldId().getSystemName()).value = instanceId;
        this._valueChange.emit(this._value);
    };
    SisInlineTableMainEntityComponent.prototype.initValueIfNotReceivedFromParent = function () {
        var _this = this;
        return this._deService.createBlankEntity(this._field.getCompoundCategorySystemName())
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (blankEntity) {
            _this._value = blankEntity;
            _this._valueChange.emit(blankEntity);
            _this._asyncState.setReady('initValueIfNotReceivedFromParent');
        }, console.error);
    };
    SisInlineTableMainEntityComponent.prototype.initInstanceField = function () {
        var _this = this;
        return this._kbService.getMetaFields(this._field.getCompoundCategorySystemName())
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (fields) {
            _this._instanceField = fields.find(function (field) { return field.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; });
            _this._asyncState.setReady('initInstanceField');
        }, console.error);
    };
    SisInlineTableMainEntityComponent.prototype.initNameFields = function () {
        var _this = this;
        return combineLatest_1.combineLatest(this._currentLanguageProvider.getCurrentLanguage(), this._kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this._field.getCompoundCategorySystemName())))
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (_a) {
            var language = _a[0], metaCategory = _a[1];
            _this._mainEntityNameFields =
                metaCategory.getNameMetaFieldIds().map(function (value) { return value.getSystemName(); });
            if (_this._value) {
                _this._mainEntityName = _this._mainEntityNameFields
                    .map(function (fieldId) { return services_1.ExtractionService.getStringFromField(_this._value, fieldId, language.getId()); }).join(' ');
            }
            _this._asyncState.setReady('initNameFields');
        }, console.error);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisInlineTableMainEntityComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_kb_service_client_js_1.MetaField),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.MetaField])
    ], SisInlineTableMainEntityComponent.prototype, "field", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], SisInlineTableMainEntityComponent.prototype, "readOnly", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.MainEntity])
    ], SisInlineTableMainEntityComponent.prototype, "value", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [])
    ], SisInlineTableMainEntityComponent.prototype, "valueChange", null);
    SisInlineTableMainEntityComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'inline-table-main-entity',
            template: require('./sis-inline-table-main-entity.component.html'),
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_de_service_client_js_1.DeService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], SisInlineTableMainEntityComponent);
    return SisInlineTableMainEntityComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.SisInlineTableMainEntityComponent = SisInlineTableMainEntityComponent;
//# sourceMappingURL=sis-inline-table-main-entity.component.js.map